/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BankAccount } from '@src/app/model/bankAccount';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ConfirmDialogService } from '@src/app/shared/dialogs/confirmDialog';
import { BankOption, GoCardlessOpenBankingService } from '@src/app/modules/txn/bank-account-page/gocardless-open-banking-service';
import { MessageService } from '@src/app/shared/message.service';

@Component({
    selector: 'app-link-bank-account',
    imports: [MatDialogModule, MatCardModule, MatButtonModule, MatIconModule],
    templateUrl: './link-bank-account.component.html',
    styleUrl: './link-bank-account.component.scss'
})
export class LinkBankAccountComponent {
    dialogRef = inject<MatDialogRef<LinkBankAccountComponent>>(MatDialogRef);
    data = inject<{
    bankAccount: BankAccount;
}>(MAT_DIALOG_DATA);
    private cds = inject(ConfirmDialogService);
    private gocob = inject(GoCardlessOpenBankingService);


    bankAccount: BankAccount;

    options: BankOption[] = [];

    constructor() {
        const data = this.data;
        const msgSvc = inject(MessageService);
        const gocob = this.gocob;


        this.bankAccount = data.bankAccount;
        gocob.getBanks().subscribe( 
            opts => this.options = opts,
            failure => msgSvc.showError(failure, ' Retrieving Available Banks')
        );
    }

    linkAccount(bo: BankOption) {
        const title = $localize `Link To Bank`
        const msg = $localize `Connect to ${bo.name} to grant access to bank accounts now?`
        const doIt = () => {
            this.gocob.requestAccess(bo).subscribe( goca => {
                window.location.href = goca.gocLink;
            }, failure => {
                console.warn('Failed With', failure)
                this.cds.alert('Error', 'Error linking bank account');
            });
            this.dialogRef.close();
        }
        this.cds.open(title, msg, doIt);
    }
}
